var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sup',[_c('v-icon',{staticStyle:{"color":"#3F9DF5","caret-color":"#3F9DF5","text-shadow":"none"},attrs:{"small":""}},[_vm._v("mdi-check-decagram")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }